import React from 'react';
import { func,string,number } from 'prop-types';
import style from './style';
import { TextInputComponent } from '../TextInput/index';



const FillInTheBlank = ({correctAnswer, answer, onAnswer, index})=>{
	const onAnswerEx = (answer) => 
		onAnswer && onAnswer(correctAnswer, -1, answer);
	return (
		<style.AnswerLayout key={correctAnswer}>
			<style.LabelLayout>{'('+(index+1)+')'}</style.LabelLayout>
			<div>
				<TextInputComponent
					onEnter={onAnswerEx}
					onBlur={onAnswerEx}
					value={answer}
				/>
			</div>
		</style.AnswerLayout>
	);
};

FillInTheBlank.propTypes = {
	correctAnswer : string.isRequired,
	onAnswer : func.isRequired,
	index : number.isRequired,
	answer : string,
};

export default FillInTheBlank;